import React from 'react'
import SolutionBaseReport from '../comp_reusable/solution_reports/SolutionBaseReport'
import injectionConfig from './injectionConfig.json'
import { CUSTOM_COMPONENT_REGISTRY } from './CustomComponentRegistry'
import { useImpactReportStore } from './stores/impactReportStore'

const ModelResult: React.FC = () => {
  return (
    <SolutionBaseReport
      injectionConfig={injectionConfig}
      componentRegistry={CUSTOM_COMPONENT_REGISTRY}
      store={useImpactReportStore}
      reportTitle="Impact model report"
    />
  )
}

export default ModelResult
